import React from 'react';
import { useFormik } from 'formik';
import apiService from 'apiService';

const FormHealthCheck = ({ data, setComplete, setHealthCheckId }) => {
  const formik = useFormik({
    initialValues: {
      hotel_registration_id: data.id,
      total_staff: '',
      business_permit_number: '',
      puskesmas: '',
      examiner_name: '',
    },
    onSubmit: async (values) => {
      const result = await apiService.post(
        '/hotel/health_check/create',
        values
      );
      if (result) {
        setHealthCheckId(result.data.id);
        setComplete(true);
      } else {
        console.log('yooo');
      }
    },
  });
  return (
    <div className='mt-3'>
      <div className='form-group row'>
        <label className='col-md-3 col-form-label form-control-label'>
          ID Pendaftaran
        </label>
        <div className='col-md-3'>
          <input
            className='form-control form-control-sm'
            name='hotel_registration_id'
            value={ formik.values.hotel_registration_id }
            disabled={ true }
            onChange={ formik.handleChange }
          />
        </div>
        <label className='col-md-3 col-form-label form-control-label'>
          Nama Pemeriksa
        </label>
        <div className='col-md-3'>
          <input
            className='form-control form-control-sm'
            name='examiner_name'
            value={ formik.values.examiner_name }
            onChange={ formik.handleChange }
          />
        </div>
      </div>
      <div className='form-group row'>
        <label className='col-md-3 col-form-label form-control-label'>
          Nama Hotel
        </label>
        <div className='col-md-3'>
          <input
            className='form-control form-control-sm'
            defaultValue={ data.hotel_name }
            disabled={ true }
          />
        </div>
        <label className='col-md-3 col-form-label form-control-label'>
          Jumlah Karyawan
        </label>
        <div className='col-md-3'>
          <input
            className='form-control form-control-sm'
            name='total_staff'
            value={ formik.values.total_staff }
            onChange={ formik.handleChange }
          />
        </div>
      </div>
      <div className='form-group row'>
        <label className='col-md-3 col-form-label form-control-label'>
          Nomor Izin Usaha
        </label>
        <div className='col-md-3'>
          <input
            className='form-control form-control-sm'
            name='business_permit_number'
            value={ formik.values.business_permit_number }
            onChange={ formik.handleChange }
          />
        </div>
        <label className='col-md-3 col-form-label form-control-label'>
          Puskesmas / Kecamatan
        </label>
        <div className='col-md-3'>
          <input
            className='form-control form-control-sm'
            name='puskesmas'
            value={ formik.values.puskesmas }
            onChange={ formik.handleChange }
          />
        </div>
      </div>
      <div className='row'>
        <div className='col'>
          <button
            className='btn btn-primary float-right'
            onClick={ formik.handleSubmit }>
            Proses
          </button>
        </div>
      </div>
    </div>
  );
};

export default FormHealthCheck;
